import styled from 'styled-components'

export const BoldText = styled.span`
  font-weight: 700;
`

export const LightText = styled.span`
  font-weight: 400;
`
